<template>
  <v-card class="pin-container">
    <div class="pin-title">{{this.thisTitle}}</div>
    <div class="pin-row">
      <span v-for="n in numberOfDigits" :class="`pin-number ${isWrong ? 'pin-error' : 'pin-ok'}`">{{getValue(n - 1)}}</span>
      <span class="pin-button" @click="doAction('close')"><v-icon>close</v-icon></span>
      <span class="pin-button" @click="isPinVisible = !isPinVisible">
        <v-icon>{{isLoading ? 'fas fa-circle-notch fa-spin' : isPinVisible ? 'visibility_off' : 'visibility'}}</v-icon>
      </span>
    </div>
    <div style="width: 100%; margin-top: 8px">
      <div class="keyboard">
        <div class="key" @click="addValue('1')"><div class="pin-button"><div>1</div></div></div>
        <div class="key" @click="addValue('2')"><div class="pin-button"><div>2</div></div></div>
        <div class="key" @click="addValue('3')"><div class="pin-button"><div>3</div></div></div>
        <div class="key" @click="addValue('4')"><div class="pin-button"><div>4</div></div></div>
        <div class="key" @click="addValue('5')"><div class="pin-button"><div>5</div></div></div>
        <div class="key" @click="addValue('6')"><div class="pin-button"><div>6</div></div></div>
        <div class="key" @click="addValue('7')"><div class="pin-button"><div>7</div></div></div>
        <div class="key" @click="addValue('8')"><div class="pin-button"><div>8</div></div></div>
        <div class="key" @click="addValue('9')"><div class="pin-button"><div>9</div></div></div>
        <div class="key" @click="clear"><div class="pin-button"><div><v-icon>delete</v-icon></div></div></div>
        <div class="key" @click="addValue('0')"><div class="pin-button"><div>0</div></div></div>
        <div class="key" @click="backspace"><div class="pin-button"><div><v-icon>backspace</v-icon></div></div></div>
      </div>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: "PinInput",
    props: {
      pinLength: Number,
      active: Boolean,
      title: {
        type: String
      }
    },
    created() {
      this.handler = (e) => {
        if (!this.active) {
          return ;
        }

        switch (e.key) {
          case '0':
          case '1':
          case '2':
          case '3':
          case '4':
          case '5':
          case '6':
          case '7':
          case '8':
          case '9':
            this.addValue(e.key);
            break;
          case 'Backspace':
            this.backspace();
            break;
          case 'Escape':
            this.doAction('close');
            break;
          default:
            console.log(e.key);
        }
      }
      window.addEventListener('keyup', this.handler);
    },
    beforeDestroy() {
      window.removeEventListener('keyup', this.handler);
    },
    computed: {
      visibleIcon() {
        return this.$root.visibleIcon(this.isPinVisible);
      },
      numberOfDigits() {
        return this.$props.pinLength;
      },
      thisTitle() {
        return this.$props.title || this.$t('Invoices.pinCodeTitle').replace('{0}', this.numberOfDigits);
      }
    },
    data() {
      return {
        currentView: 'Orders',
        isLoading: false,
        isWrong: false,
        isPinVisible: false,
        value: []
      };
    },
    methods: {
      getValue(index) {
        if (index < this.value.length) {
          return this.isPinVisible ? this.value[index] : '•';
        }
        return '';
      },
      addValue(char) {
        this.isWrong = false;
        console.log('Number ', char);
        if (this.value.length < this.numberOfDigits) {
          this.value.push(char);
        }
        console.log('Number of Digits', this.numberOfDigits);
        if (this.value.length >= this.numberOfDigits) {
          this.isLoading = true;
          this.$http.get(this.$root.route('account/pin?pin=' + this.value.join('')))
            .then(
              // Success
              response => {
                this.isLoading = false;
                this.doAction('success');
              },
              // Failure
              response => {
                this.isWrong = true;
                this.isLoading = false;
                this.beep();
                setTimeout(() => {
                  this.clear();
                },1000)
              }
          );

          // const actionName = (this.value.join('') === this.$props.validPin) ? 'success' : 'failed';
          // if (actionName === 'failed') {
          //   this.beep();
          // } else {
          //   this.doAction(actionName);
          // }
        }
      },
      beep() {
        const snd = new Audio("data:audio/wav;base64,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");
        snd.play();
      },
      backspace() {
        this.isWrong = false;
        this.value.pop();
      },
      clear() {
        this.isWrong = false;
        this.value = [];
      },
      doAction(actionName) {
        this.clear();
        this.$emit('action', actionName)
      }
    }
  }
</script>

<style scoped>
  .pin-error {
    color: red;
  }
  div.pin-container {
    display: inline-block;
    text-align: center;
  }
  div.pin-title {
    padding: 8px;
    border-bottom: 1px solid var(--v-secondary-lighten4);
  }

  div.pin-row {
    width: 100%;
    display: block;
    font-size: 20px;
    padding: 8px 0 0 0px;
    cursor: default;
    line-height: 32px;
  }
  span.pin-number {
    display: inline-block;
    width: 7%;
  }
  span.pin-button {
    display: inline-block;
    float: right;
    margin-right: 10px;
    width: 32px;
  }

  .keyboard {
    width: 200px;
    text-align: center;
    border-top: 1px solid var(--v-secondary-lighten4);
    padding-top: 8px;
  }
  .key {
    width: 54px;
    height: 57px;
    display: inline-block;
    position: relative;
    margin: 0 2px;
  }
  .key::after {
    content: '';
    display: block;
    margin-top: 100%;
  }
  .key .pin-button {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .key .pin-button > div {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    font-size: 28px;
  }
  .pin-button > div > i{
    vertical-align: inherit;
  }

  .pin-button {
    background-color: var(--v-secondary-lighten4);
    border-radius: 3px;
    cursor: pointer;
    user-select: none;
  }
  .pin-button:active {
    box-shadow: 0 5px #666;
    transform: translateY(4px);
  }
  .pin-button:hover {
    opacity: 0.8
  }
</style>
